<template>
  <div
    :style="{
      padding: '12px 0',
      borderLeft: level >= 1 ? '2px solid #e0e0e0' : '',
      paddingLeft: level >= 1 ? '12px' : '',
      borderBottom: level === 0 ? '1px solid #ccc' : '',
      backgroundColor: level >= 5 ? '#f9f9f9' : ''
    }"
  >
    <!-- Row: Avatar | Name & Time | Reply Button -->
    <div
      style="display: flex; justify-content: space-between; align-items: flex-start;"
    >
      <!-- Avatar + Content -->
      <div style="display: flex; gap: 10px; flex: 1">
        <!-- Avatar -->
        <div class="icon-block initial" style="flex-shrink: 0">
          <div v-if="entityUserInfoData[comment.created_by]?.avatar">
            <img
              :src="entityUserInfoData[comment.created_by].avatar"
              alt="IMG"
              width="35"
              height="35"
              style="border-radius: 50%"
            />
          </div>
          <div class="icon" v-else>
            <div class="initial-text">
              <span>{{ getInitials(comment) }}</span>
            </div>
          </div>
        </div>

        <!-- Name + Date + Comment -->
        <div style="flex: 1">
          <div style="display: flex; align-items: center; gap: 6px;">
            <div v-if="level >= 1" class="text-xs text-gray-500">↳  </div>
            <div>
              {{
                comment.created_by === getAuthenticatedUser._id
                  ? "You"
                  : entityUserInfoData[comment.created_by]?.first_name +
                    " " +
                    entityUserInfoData[comment.created_by]?.last_name
              }}
              <span class="date-time text-dark fw-medium opacity-50 ml-2">
                {{ comment.created_at | getFormattedDateTypeThree }}
              </span>
            </div>
          </div>
          <p style="margin: 6px 0" v-html="comment.comment"></p>
        </div>
      </div>

      <!-- Reply Button -->
      <div style="margin-left: 10px">
        <span style="color: #1890ff; cursor: pointer" @click="replyToComment(comment._id)">Reply</span>
      </div>
    </div>

    <!-- View Replies Button -->
    <div v-if="comment.replies?.length" style="margin-left: 45px; margin-top: 8px">
      <button
        @click="toggleReplies"
        style="background: none; border: none; color: #1890ff; cursor: pointer; padding: 0;"
      >
        {{
          showReplies
            ? "Hide Replies"
            : `View Replies (${comment.replies.length})`
        }}
      </button>
    </div>

    <!-- Recursive Nested Replies -->
    <div v-if="showReplies">
      <CommentBlock
        v-for="reply in comment.replies"
        :key="reply._id"
        :comment="reply"
        :entityUserInfoData="entityUserInfoData"
        :level="level + 1"
        @reply="replyToComment"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "CommentBlock",
  props: {
    comment: Object,
    entityUserInfoData: Object,
    level: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      showReplies: false,
    };
  },
  computed: {
    ...mapGetters("auth", ["getAuthenticatedUser"]),
  },
  methods: {
    toggleReplies() {
      this.showReplies = !this.showReplies;
    },
    getInitials(comment) {
      const firstName =
        this.entityUserInfoData[comment.created_by]?.first_name || "";
      const lastName =
        this.entityUserInfoData[comment.created_by]?.last_name || "";
      return (firstName[0]?.toUpperCase() || "") + (lastName[0]?.toUpperCase() || "");
    },
    replyToComment(commentId) {
      this.$emit("reply", commentId);
    },
  },
};
</script>

<style scoped>
.text-xs {
  font-size: 12px;
}
</style>
